// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Buefy from 'buefy'

import { ApolloClient } from 'apollo-client'
import { setContext } from 'apollo-link-context'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'

import VueApollo from 'vue-apollo'

Vue.config.productionTip = false

const httpLink = new HttpLink({
  // URL to graphql server, you should use an absolute URL here
  // uri: 'http://localhost:8000/graphql/'
  // uri: 'https://papers-lib.test.hedera.online/graphql/'
  uri: 'https://online-library.prod.hedera.online/graphql/'
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from localstorage if it exists
  let data = localStorage.getItem('app-token')
  let token = null
  if (data !== null) {
    data = data && JSON.parse(data)
    token = data.loginUser && data.loginUser.token
  }

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : null
    }
  }
})

// create the apollo client
const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $error: function () {
      return (errors) => {
        console.log('Provider $error handler')
        console.log(errors.graphQLErrors)
      }
    }
  }
})

// install the vue plugin
Vue.use(VueApollo)

Vue.use(Buefy)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  apolloProvider,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js